module.exports = __webpack_public_path__ + "img/MTCIAKBK.9d997f03.png";